function scorePassword(password: string): number {
  if (!password) return 0;
  let score = 0;
  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score++;
  if (/\d/.test(password)) score++;
  if (/[^a-zA-Z0-9]/.test(password)) score++;
  return Math.min(score, 4);
}

const LEVELS = [
  { label: 'Weak', color: 'bg-red-400', text: 'text-red-400' },
  { label: 'Fair', color: 'bg-amber-400', text: 'text-amber-400' },
  { label: 'Good', color: 'bg-yellow-400', text: 'text-yellow-400' },
  { label: 'Strong', color: 'bg-green-400', text: 'text-green-400' },
];

export function PasswordStrengthMeter({ password }: { password: string }) {
  if (!password) return null;
  const score = scorePassword(password);
  const level = LEVELS[Math.max(score - 1, 0)];

  return (
    <div className="mt-2" aria-hidden={false}>
      <div className="flex gap-1.5" role="progressbar" aria-valuenow={score} aria-valuemin={0} aria-valuemax={4} aria-label="Password strength">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={`h-1 flex-1 rounded-full transition-colors ${i < score ? level.color : 'bg-white/10'}`}
          />
        ))}
      </div>
      <p className={`text-xs mt-1.5 font-semibold ${level.text}`}>{level.label}</p>
    </div>
  );
}
